<template>
  <div class="footer">
    <footer id="footer" class="footer light-background">
      <div class="container footer-top">
        <div class="row gy-4">
          <div class="col-lg-4 col-md-6 footer-about">
            <a class="logo d-flex align-items-center">
              <span class="sitename">MatrixHub Company Ltd.</span>
            </a>
            <p class="footer-tagline">
              Building modern digital experiences with strategy, design, and technology.
            </p>
            <div class="footer-contact pt-3">
              <p>MatrixHub Company Ltd.</p>
              <p>Capital CityMall, Office #57</p>
              <p>P. O. Box 2763</p>
              <p>Dodoma, Tanzania</p>
              <p class="mt-2"><strong>Phone:</strong> <span>{{ phone }}</span></p>
              <p><strong>Email:</strong> <a :href="'mailto:' + email" class="text-info">{{ email }}</a></p>
            </div>
            <div class="social-links d-flex mt-4">
              <a href="https://x.com/matrixhubco" target="_blank" rel="noopener noreferrer"><i class="bi bi-twitter-x"></i></a>
              <a href="https://web.facebook.com/matrixhubco" target="_blank" rel="noopener noreferrer"><i class="bi bi-facebook"></i></a>
              <a href="https://www.instagram.com/matrixhubco/" target="_blank" rel="noopener noreferrer"><i class="bi bi-instagram"></i></a>
              <a href="https://tz.linkedin.com/company/matrixhubco" target="_blank" rel="noopener noreferrer"><i class="bi bi-linkedin"></i></a>
            </div>
          </div>
          <div class="col-lg-4 col-md-6 footer-links">
            <h4>Company</h4>
            <ul>
              <li><router-link to="/">Home</router-link></li>
              <li><router-link to="/about">About us</router-link></li>
              <li><router-link to="/how-we-work">How we Work!</router-link></li>
              <li><router-link to="/who-we-serve">Who We Serve</router-link></li>
              <li><router-link to="/services">Services</router-link></li>
              <li><router-link to="/products">Products</router-link></li>
              <li><router-link to="/team">Team</router-link></li>
              <li><router-link to="/contact">Contact</router-link></li>
<!--              <li>-->
<!--                <router-link :to="{ path: '/privacy-policy-page', }">-->
<!--                  Privacy Policy-->
<!--                </router-link>-->
<!--              </li>-->
            </ul>
          </div>
          <div class="col-lg-4 col-md-6 footer-links">
            <h4>Our Services</h4>
            <ul>
              <li><router-link to="/services">Custom Web Development</router-link></li>
              <li><router-link to="/services">Mobile App Solutions</router-link></li>
              <li><router-link to="/services">UI/UX Design</router-link></li>
              <li><router-link to="/services">Cybersecurity Solutions</router-link></li>
              <li><router-link to="/services">Cloud Computing</router-link></li>
              <li><router-link to="/services">DevOps & Automation</router-link></li>
              <li><router-link to="/services">...and many more</router-link></li>
            </ul>
          </div>
<!--          <div class="col-lg-2 col-md-3 footer-links">-->
<!--            <h4>Hic solutasetp</h4>-->
<!--            <ul>-->
<!--              <li><a href="#">Molestiae accusamus iure</a></li>-->
<!--              <li><a href="#">Excepturi dignissimos</a></li>-->
<!--              <li><a href="#">Suscipit distinctio</a></li>-->
<!--              <li><a href="#">Dilecta</a></li>-->
<!--              <li><a href="#">Sit quas consectetur</a></li>-->
<!--            </ul>-->
<!--          </div>-->

<!--          <div class="col-lg-2 col-md-3 footer-links">-->
<!--            <h4>Nobis illum</h4>-->
<!--            <ul>-->
<!--              <li><a href="#">Ipsam</a></li>-->
<!--              <li><a href="#">Laudantium dolorum</a></li>-->
<!--              <li><a href="#">Dinera</a></li>-->
<!--              <li><a href="#">Trodelas</a></li>-->
<!--              <li><a href="#">Flexo</a></li>-->
<!--            </ul>-->
<!--          </div>-->
        </div>
      </div>
      <div class="container copyright text-center mt-4">
        <p>© {{currentYear}} <span>MatrixHub Company Ltd.</span> All Rights Reserved.</p>
        <div class="credits">
          Designed by <a target="_blank" rel="noopener noreferrer" href="https://matrixhub.co.tz/">MatrixHub Company Ltd.</a>
        </div>
      </div>
    </footer>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'FooterComponent',
  data: () => ({
    email: 'info@matrixhub.co.tz',
    phone: '(+255) 754 690 060 | 765 268 371',
  }),
  computed: {
    currentYear() {
      return new Date().getFullYear();
    },
  },

});
</script>
